export default __webpack_public_path__ + "static/media/Pretendard-ExtraLight.1a26bede.woff2";